// extracted by mini-css-extract-plugin
module.exports = {"container":"FinishedRegistration_container__1BitB","msg":"FinishedRegistration_msg__1OG7o","continueBtn":"FinishedRegistration_continueBtn__3W1De"};